import { Navigate, NavLink, Outlet, useNavigate } from "react-router";

import { checkTabIsActive, PageHeading, Spinner, Tabs } from "@prequel/shared-components";

import { useRecipient } from "@/api/queries/recipients";
import Breadcrumbs from "@/components/Breadcrumbs";
import { useRequiredParam } from "@/layouts/Navigation/useRequiredParam";
import BufoPage from "@/pages/BufoPage";
import { isBufoUUID } from "@/pages/BufoPage/bufo";

const RecipientPage = () => {
  const recipientID = useRequiredParam("recipientID");
  const navigate = useNavigate();
  const { data: recipient, isLoading } = useRecipient(recipientID);

  const tabs = [
    <NavLink key="Details" to={`/recipients/${recipientID}`} className={checkTabIsActive} end>
      Details
    </NavLink>,
    <NavLink key="Destinations" to={`/recipients/${recipientID}/destinations`} className={checkTabIsActive} end>
      Destinations
    </NavLink>,
    <NavLink key="Admin" to={`/recipients/${recipientID}/admin`} className={checkTabIsActive} end>
      Admin
    </NavLink>,
  ];

  // Check for easter egg before rendering
  if (isBufoUUID(recipientID)) {
    return <BufoPage />;
  }

  if (isLoading) {
    return <Spinner />;
  }

  if (!recipient) {
    return <Navigate to="/recipients" replace />;
  }

  return (
    <div className="max-w-6xl px-7 py-4">
      <PageHeading
        title={recipient.name}
        onGoBack={() => navigate("/recipients")}
        breadcrumbs={<Breadcrumbs dynamicLabel={recipient.name} />}
      />
      <div className="flex-1">
        <div className="relative mx-auto">
          <div className="pt-0 pb-16">
            <div className="pb-6">
              <Tabs tabs={tabs} />
              <Outlet context={{ recipient, recipientID }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipientPage;
